import { hook, Hooks } from 'Components/Hooks';

import { AppConnectionErrorModal } from 'WebCall/UIComponents';
import LinkCallUI from './LinkCallUI';

export default function LinkAppUI({ ctrl }) {
  const hooks = new Hooks();
  const ctx = {
    hooks,
    ctrl,
  };

  const root = (
    <div
      class="pnlWebCallApp"
      class:always-listen-only={ctrl.alwaysListenOnly}
      class:disable-command-buttons={ctrl.disableCommandButtons}
    >
      <AppConnectionErrorModal ctx={ctx} anchored={false} />

      <div use:hook={hooks.showEq('currentCallController', ctrl.callController)}>
        <LinkCallUI ctrl={ctrl.callController} />
      </div>
    </div>
  );

  ctrl.on('update', () => hooks.run(ctrl));
  hooks.run(ctrl);

  return root;
}
